import React, {PropsWithChildren, useCallback} from "react";
import {useTenant} from "../context/tenant";
import {Box, Container, Stack} from "@mui/material";
import {SUPPORTED_LANGUAGES, useLocalization} from "../i18n";
import {LanguageSwitcher} from "@variocube/app-ui";

import BalzKlubLogo from "../assets/balzklub-logo.png";
import VariocubeLogo from "../assets/variocube.svg";

export function AppSimplifiedShell({children}: PropsWithChildren<{}>) {
	const {tenant} = useTenant();
	const {t, ...rest} = useLocalization();

	const renderTenantLogo = useCallback(() => {
		const tenantId = tenant?.id ?? '';
		switch (tenantId) {
			case 'balzklub':
				return <img alt="balzklub" style={{ width: '100px', height: "auto", padding: '8px' }} src={BalzKlubLogo}/>;
			case 'variocube':
				return <VariocubeLogo width="auto" height="75px" />;
			default:
				return <span />;
		}
	}, [tenant])

	return (
		<Container maxWidth="sm">
			<Stack
				direction="column"
				justifyContent="center"
				minHeight="calc(100dvh - 50px)"
				padding="2rem 1rem"
				overflow="auto"
				gap={1}
			>
				{tenant !== undefined && (
					<Stack
						direction="row"
					>
						<Box flexGrow={1} />
						<LanguageSwitcher
							languages={SUPPORTED_LANGUAGES}
							{...rest}
						/>
					</Stack>
				)}
				<Stack
					direction="row"
					justifyContent="center"
				>
					{renderTenantLogo()}
				</Stack>
				<Stack
					direction="column"
					justifyContent="center"
					flexGrow={1}
				>
					{children}
				</Stack>
			</Stack>
		</Container>
	)
}
